module.exports = __webpack_public_path__ + "img/tip-success.4f42bbc9.png";